import React, { useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { TweenLite } from 'gsap';
import ContractAddendumClause from './redesign/ContractGenerationModels/ContractAddendumClause';
import LeaseClause from 'src/models/LeaseClause';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

interface IClientApprovedLeaseClausesProps extends Partial<Pick<UseFormMethods, 'getValues' | 'register' | 'errors'>> {
    contractClauses: Array<ContractAddendumClause>;
    selectedClauses: Array<number>;
    isInHanded: boolean;

    updateProcessing: (current: number, selection: Array<number>) => void;
}

const ClientApprovedLeaseClauses = (props: IClientApprovedLeaseClausesProps) => {
    const toggleRef = useRef([]);
    
    const isClauseSelected = (index: number) => {
        let currentSelection = [...props.selectedClauses];
        let formValues = props.getValues();
        let isSelected = formValues.contractClauses ? formValues.contractClauses[index]?.contractAddendumClauseId > 0 : false;
        let existing = currentSelection.indexOf(currentSelection.find(cs => cs === index));
        if (existing > -1 && isSelected === false) {
            currentSelection.splice(existing, 1);
        } else if (existing === -1 && isSelected === true) {
            currentSelection.push(index);
        }
        props.updateProcessing(index, currentSelection);
    };

    const toggleClauseTooltip = (state: boolean, index: number, clientX: number, clientY: number) => {
        if (state) {
            TweenLite.set(
                toggleRef.current[index],
                { top: `${clientY - 10}`, left: `${clientX + 10}`, height: 'auto', display: 'inline-block', background: 'white', border: '2px solid #6393C1', zIndex: 100 }
            );
        } else {
            TweenLite.to(toggleRef.current[index], 0.2, { height: '2.5rem', display: 'none', background: 'transparent', borderColor: 'transparent', zIndex: 0 });
        }
    };

    if (props.contractClauses?.length > 0) {
        return (
            <div>
                <div className="form-row">
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '15%' }}>
                            <span className="column-heading">Type</span>
                        </div>
                        <div style={{ width: '10%' }}>
                            <span className="column-heading">Response</span>
                        </div>
                        <div style={{ width: '75%' }}>
                            <span className="column-heading">Language</span>
                        </div>
                    </div>
                </div>

                {props.contractClauses.map((clause: LeaseClause, index: number) => {
                    return (
                        <div
                            key={`contractClauses-${index}`}
                            className="form-row"
                        >
                            <div style={{ width: '15%' }}>
                                {clause.leaseClauseType}
                            </div>
                            <div style={{ width: '10%' }}>
                                <RHFSelect
                                    name={`contractClauses[${index}].contractAddendumClauseId`}
                                    register={props.register}
                                    errors={props.errors}
                                    options={[
                                        { value: clause.id, label: 'Yes' },
                                        { value: 0, label: 'No' },
                                    ]}
                                    disabled={props.isInHanded}
                                    onChange={() => isClauseSelected(index)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className={props.selectedClauses.find(sc => sc === index) !== undefined ? '' : 'disabled'} style={{ width: '75%' }}>
                                <div style={{display: 'flex'}}>
                                    <span
                                        style={{fontSize: '20px'}}
                                        onMouseOver={(e) => toggleClauseTooltip(true, index, e.clientX, e.clientY)}
                                        onMouseOut={() => toggleClauseTooltip(false, index, 0, 0)}
                                    >
                                        👁‍🗨
                                    </span>
                                    <span
                                        style={{ width: '80em', textOverflow: 'ellipsis', overflow: 'hidden', display: 'inline-block', whiteSpace: 'nowrap' }}
                                    >
                                        {clause.clauseText || 'No Description'}
                                    </span>
                                    <span
                                        ref={el => toggleRef.current[index] = el}
                                        style={{
                                            borderRadius: '5px',
                                            border: '2px solid #6393C1',
                                            display: 'none',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            position: 'absolute',
                                            padding: '.3rem',
                                            background: 'transparent',
                                            borderColor: 'transparent',
                                            zIndex: 10,
                                            height: 'auto',
                                        }}
                                    >
                                        {clause.clauseText || 'No Description'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
    return <div />;
};

export default ClientApprovedLeaseClauses;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/ClientApprovedLeaseClauses.tsx